import http from "@/http-credential";

export default new class LoginConfigService {

    search(groupName, configKey, mediaType, isActive, page, limit) {
        const params = { page, limit };
        if (groupName !== null && groupName !== undefined && groupName !== '') params.groupName = groupName;
        if (configKey !== null && configKey !== undefined && configKey !== '') params.configKey = configKey;
        if (mediaType !== null && mediaType !== undefined && mediaType !== '') params.mediaType = mediaType;
        if (isActive !== null && isActive !== undefined && isActive !== '') params.isActive = isActive;
        return http.get(`/web/onekids/login-config/search`, { params });
    }

    detail(id) {
        return http.get(`/web/onekids/login-config/detail/${id}`);
    }

    create(data) {
        return http.post(`/web/onekids/login-config/create`, data);
    }

    update(id, data) {
        return http.put(`/web/onekids/login-config/update/${id}`, data);
    }

    delete(id) {
        return http.delete(`/web/onekids/login-config/delete/${id}`);
    }
}

